import React, { useCallback, useEffect, useState } from 'react';
import PageContainer from '../../../components/Redesing/page-container';
import PageContent from '../../../components/Redesing/page-content';
import { useParams } from 'react-router';
import { changeTab } from '../../../utils';
import OrganizationSupportTickets from './organizationSupportTickets';
import ProblemsTags from '../problems-tags';

function OrganizationSupportTicketsIndex() {
  const { currentTab = 'tickets' } = useParams<{ currentTab: string }>();
  const [currentTabState, setCurrentTabState] = useState(currentTab);

  const handleTabsChange = useCallback(
    (event: React.SyntheticEvent, value: React.SetStateAction<string>) => {
      changeTab(value, currentTab, 'problems');
    },
    [currentTab]
  );

  useEffect(() => {
    if (currentTab !== currentTabState) {
      setCurrentTabState(currentTab);
    }
  }, [currentTab, currentTabState]);

  return (
    <PageContainer spaceName={'Support Tickets'}>
      <PageContent
        detailedView={false}
        currentTabV={currentTabState}
        handleTabsChange={handleTabsChange}
        tabsList={[
          {
            label: 'Tickets',
            value: 'tickets',
          },
          {
            label: 'Tags',
            value: 'tags',
          },
        ]}
        tabsChildren={
          <>
            {currentTabState === 'tickets' && <OrganizationSupportTickets />}
            {currentTabState === 'tags' && <ProblemsTags />}
          </>
        }
      />
    </PageContainer>
  );
}

export default OrganizationSupportTicketsIndex;
